import React from 'react';
import AddUser from '../../components/user/add_user/Component';

const Component = () => {
  return (
      <AddUser componentTitle="Customer"/>
  )
}

export default Component
